<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
        <mat-panel-title>
            LCA Details
        </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- Employment-Based Nonmigrant Visa Information  -->
    <form [formGroup]="lcaEFileApplication">
        <div class="p-4 padding-bottom-0">
            <div class="row">
                <h5 class="col-md-8 labelText"> Employment-Based Nonmigrant Visa Information </h5>
                <div class="col-md-4 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                    <button class="clear-data-button" (click)="clearData()">
                        <i class="fa fa-repeat"></i> Clear Data
                    </button>
                </div>
            </div>


            <div class="row">
                <div class="form-group col-md-4">
                    <!-- <label class="label-cls required">Visa Classification Type</label>
                    <select class="im-input"
                        name="visaType"
                        formControlName="visaType"
                        > 
                        <option *ngFor="let item of visaTypeList" [value]="item.code">
                            {{item.name}}
                        </option>
                    </select> -->
                    <mat-form-field>
                        <label class="label-cls required">Visa Classification Type</label>
                        <mat-select name="visaType" formControlName="visaType"
                            (selectionChange)="onChangeVisa($event.value)">
                            <mat-option *ngFor="let item of visaTypeList" [value]="item.code">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-12 p-0">
                <hr class="dashed-border">
            </div>
        </div>


        <!-- Temporary Need Information -->
        <div class="p-4 padding-top-0">
            <h5 class="col-md-12 labelText"> Temporary Need Information </h5>
            <div class="row mt-2">
                <!-- First Name -->
                <div class="form-group col-md-4">
                    <label class="label-cls required">Job Title</label>
                    <input class="im-input" name="jobTitle" formControlName="jobTitle" type="text"
                        placeholder="Enter" />
                    <span class="invalid-message"
                        *ngIf="(lcaEFileApplication.get('jobTitle').touched  && lcaEFileApplication.get('jobTitle').invalid)">
                        {{ getGlobalErrorMessages("JOBTITTLE") }}
                    </span>
                </div>

                <!-- SOC Code -->
                <div class="p-0 m-0 form-group col-md-4">
                    <mat-label>SOC Code</mat-label>
                    <mat-form-field>
                        <mat-select name="socCode" formControlName="socCode"
                            (selectionChange)="onChangeOccupationTitle($event.value)" (mouseover)="getListSocCOde()">
                            <input (keyup)="onKey($event.target.value)" placeholder="search soc codes">
                            <ng-container *ngFor="let item of socCodeListFiltered">
                                <mat-option [value]="item.socCode">
                                    {{item.socCode}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- <div class="form-group col-md-4"> 
                <input class="im-input" type="text" #searchbar  formControlName="socCode"  placeholder="Search Here" />
                <mat-form-field>
                <mat-select name="socCode">
                                <mat-option *ngFor="let item of socCodeList" [value]="item?.socCode"  >
                                  {{item?.socCode}} {{item?.version}}
                                </mat-option> 
                            </mat-select>
                        </mat-form-field> -->

                <!-- <mat-form-field>
                    <label class="label-cls required">SOC (ONET/OES) Code </label>
                    <mat-select name="socCode"
                                formControlName="socCode"
                                >
                                <mat-option *ngFor="let item of socCodeList" [value]="item?.version">
                                  {{item?.socCode}} {{item?.version}}
                                </mat-option> 
                              </mat-select>
                          </mat-form-field>  -->
                <!-- Last Name (Family Name) -->


                <div class="form-group col-md-4">
                    <label class="label-cls required">SOC (ONET/OES) Occupation Title</label>
                    <input class="im-input" name="socTitle" formControlName="socTitle" type="text" placeholder="Enter"
                        [readonly]="enableReadOnlyMode" />
                    <!-- <mat-hint>Ex. : 12-1234.00</mat-hint> -->
                    <span class="invalid-message"
                        *ngIf="(lcaEFileApplication.get('socTitle').touched  && lcaEFileApplication.get('socTitle').invalid)">
                        {{ getGlobalErrorMessages("SOC_OCCUPATION") }}
                    </span>
                </div>

            </div>




            <div class="row mt-2">
                <div class="col-4 mt-1 pl-3">
                    <label class="control-lbl required mt-2 label-cls">Is this a full position ? </label>
                    <div class="row pt-2">
                        <mat-radio-group name="isFullTime" formControlName="isFullTime" aria-label="Select an option"
                            required>
                            <mat-radio-button [value]="true">Yes </mat-radio-button>
                            <mat-radio-button [value]="false">No </mat-radio-button>
                        </mat-radio-group>
                    </div>

                </div>
                <div class="col-4">
                    <div class="col-7 p-0">
                        <label class="control-lbl  label-cls d-block required"> Employment Start Date</label>
                        <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">

                            <input matInput name="employmentStartDate" formControlName="employmentStartDate"
                                [matDatepicker]="picker1" (dateChange)="onChangeEndDate()" placeholder="MM/DD/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <span class="invalid-message"
                            *ngIf="(this.lcaEFileApplication.controls.visaType.value ==='H1-B' || this.lcaEFileApplication.controls.visaType.value ==='H1-B1') && !showDateError">
                            {{ getGlobalErrorMessages("INVALID_H1B") }}
                        </span>
                        <span class="invalid-message"
                            *ngIf="this.lcaEFileApplication.controls.visaType.value ==='E3' && !showDateError">
                            {{ getGlobalErrorMessages("INVALID_E3") }}
                        </span>
                    </div>
                </div>
                <div class="col-4 ">
                    <div class="col-7 p-0">
                        <label class="control-lbl  label-cls d-block required"> Employment End Date</label>
                        <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                            <input matInput name="employmentEndDate" formControlName="employmentEndDate"
                                [matDatepicker]="picker2"
                                [min]="this.lcaEFileApplication.controls.employmentStartDate.value"
                                (dateChange)="onChangeEndDate()" placeholder="MM/DD/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>

                </div>
            </div>

            <div class="row mt-2">
                <div class="col-4 ">
                    <div class="col-7 p-0">
                        <label class="control-lbl required mt-2 label-cls">Total worker Position</label>
                        <input type="number" min="0" class="im-input" placeholder="Enter" name="totalCount"
                            formControlName="totalCount" required />

                        <span class="invalid-message" *ngIf="(lcaEFileApplication.get('totalCount').touched  &&
                     lcaEFileApplication.get('totalCount').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>


                    </div>
                </div>
            </div>


        </div>





        <!-- Indicate Total Workers in each applicable category -->

        <div class="p-4 padding-top-0">
            <h5 class="col-md-12 labelText"> Indicate Total Workers in each applicable category </h5>



            <div class="row mt-2">
                <!-- First Name -->
                <div class="form-group col-md-4">
                    <label class="label-cls required">New Employment</label>
                    <input class="im-input" name="newEmploymentCount" formControlName="newEmploymentCount" type="number"
                        placeholder="Enter" required />
                    <span class="invalid-message"
                        *ngIf="(lcaEFileApplication.get('newEmploymentCount').touched && lcaEFileApplication.get('newEmploymentCount').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <!-- Middle Name -->
                <div class="form-group col-md-4">
                    <label class="label-cls required">Continuation of Employment</label>
                    <input class="im-input" type="number" name="continueApprovedCount"
                        formControlName="continueApprovedCount" placeholder="Enter" required />
                    <span class="invalid-message"
                        *ngIf="(lcaEFileApplication.get('continueApprovedCount').touched && lcaEFileApplication.get('continueApprovedCount').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <!-- Last Name (Family Name) -->
                <div class="form-group col-md-4">
                    <label class="label-cls required">Change in Employment</label>
                    <input class="im-input" type="number" name="changeApproveCount" formControlName="changeApproveCount"
                        placeholder="Enter" required />
                    <span class="invalid-message"
                        *ngIf="(lcaEFileApplication.get('changeApproveCount').touched && lcaEFileApplication.get('changeApproveCount').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
            </div>


            <div class="row">
                <div class="col-4 ">
                    <div class="col-7 p-0">
                        <label class="control-lbl required mt-2 label-cls">New Concurrent Employment</label>
                        <input type="number" name="concurrentEmploymentCount"
                            formControlName="concurrentEmploymentCount" min="0" class="im-input" placeholder="Enter"
                            required />
                        <span class="invalid-message"
                            *ngIf="(lcaEFileApplication.get('concurrentEmploymentCount').touched && lcaEFileApplication.get('concurrentEmploymentCount').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </div>

                </div>
                <div class="col-4">
                    <div class="col-7 p-0">
                        <label class="control-lbl required mt-2 label-cls">Change in Employer</label>
                        <input type="number" min="0" class="im-input" name="employerChangeCount"
                            formControlName="employerChangeCount" placeholder="Enter " required>
                        <span class="invalid-message"
                            *ngIf="(lcaEFileApplication.get('employerChangeCount').touched && lcaEFileApplication.get('employerChangeCount').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </div>
                </div>
                <div class="col-4">
                    <div class="col-7 p-0">
                        <label class="control-lbl required mt-2 label-cls">Amended Petition</label>
                        <input type="number" min="0" class="im-input" name="amendedPetitionCount"
                            formControlName="amendedPetitionCount" placeholder="Enter " required>
                        <span class="invalid-message"
                            *ngIf="(lcaEFileApplication.get('amendedPetitionCount').touched && lcaEFileApplication.get('amendedPetitionCount').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </div>
                </div>
            </div>



        </div>
    </form>

    <!-- Confirm Reset Modal -->
    <p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>